import { render, staticRenderFns } from "./RuleActionsSettings.vue?vue&type=template&id=5f920a26&"
import script from "./RuleActionsSettings.vue?vue&type=script&lang=ts&"
export * from "./RuleActionsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports